export var SEARCH_APOLLO_CACHE_CONFIG = {
  typePolicies: {
    CartClubSubscriptionOption: {
      keyFields: ["id", "price", ["amount"]]
    }
  }
};